import PptxGenJS from "pptxgenjs";
import { LAYOUT } from "./helpers/constants";
import { coverSlide, aboutSellerSlide, generalDetailsSlide, connectionInfraSlide, otherInfoSlide, executiveSummarySlide, AdvisorsSlide, backCoverSlide } from "./slides";
import { PPTOpportunityData } from "../../types";
import { PPTImageManager, preloadImagesForProject } from "./helpers/image-manager";
import { topcoInfoSlide } from "./slides/topco-info";

export async function buildTeaser(data: PPTOpportunityData) {
    const pptx = new PptxGenJS();

    const { id, name, aboutSeller, executiveSummary, projects, technologies } = data;

    // 1. Instance of Image manager
    const imageManager = new PPTImageManager();
    await preloadImagesForProject(imageManager, {
        technologies: technologies.types,
    });

    pptx.defineLayout({
        name: "A4Portrait",
        width: LAYOUT.width,
        height: LAYOUT.height
    });
    pptx.layout = "A4Portrait";

    // Cover slide
    coverSlide(pptx, { projectTitle: data.name, id }, imageManager);

    //Executive Summary
    executiveSummarySlide(pptx, { id, name, executiveSummary, projects, technologies }, imageManager);

    // About the seller slide
    aboutSellerSlide(pptx, { id, name, aboutSeller }, imageManager);

    // Project Info
    for (const project of projects) {
        generalDetailsSlide(pptx, { projectTitle: data.name, project }, imageManager);
        if (project.isTopco) {
          topcoInfoSlide(pptx, { projectTitle: data.name, project }, imageManager);
        } else {
          connectionInfraSlide(pptx, { projectTitle: data.name, project }, imageManager);
          otherInfoSlide(pptx, { projectTitle: data.name, project }, imageManager);
        }
    }

    // Advisors slide
    AdvisorsSlide(pptx, imageManager);

    // Back Cover slide
    backCoverSlide(pptx, { id }, imageManager);

    // return pptx;
    const fileName = `Teaser_${name.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pptx`;

    await pptx.writeFile({ fileName });
}
